/**
 * ErrorText — строка с текстом ошибки под контентом (не боксовый Note).
 */
import type { ReactNode } from "react";

export function ErrorText({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <div className={`text-[13px] text-red-400 ${className}`}>{children}</div>;
}
